import { render, staticRenderFns } from "./WebsiteInformation.vue?vue&type=template&id=54a3c2dd&"
import script from "./WebsiteInformation.vue?vue&type=script&lang=js&"
export * from "./WebsiteInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a3c2dd')) {
      api.createRecord('54a3c2dd', component.options)
    } else {
      api.reload('54a3c2dd', component.options)
    }
    module.hot.accept("./WebsiteInformation.vue?vue&type=template&id=54a3c2dd&", function () {
      api.rerender('54a3c2dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/WebsiteInformation.vue"
export default component.exports